import React, { Component } from "react";
import {
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Modal,
  ModalBody,
} from "reactstrap";

class PreparationTime extends Component {
  constructor(props) {
    super(props);
    this.state = {
      time: this.props.time,
      minute: null,
      selected_minute: this.props.time ? (this.props.time % 1440) % 60 : 0,
      selected_hour: this.props.time
        ? ((this.props.time % 1440) / 60).toFixed(0)
        : 0,
      selected_day: this.props.time ? (this.props.time / 1440).toFixed(0) : 0,
      minutes: Array.from(Array(61).keys()),
      hour: null,
      hours: Array.from(Array(25).keys()),
      day: null,
      days: Array.from(Array(1001).keys()),
    };
  }

  render() {
    return (
      <div>
        <Modal
          dir="rtl"
          zIndex="9999999"
          className="m-0"
          contentClassName="border-0 position-fixed fixed-bottom rounded-top-28 w-auto"
          isOpen={this.props.timeModal}
          toggle={() => this.props.changeModal(!this.props.timeModal)}
        >
          <ModalBody className="row mx-0 p-4">
            <div className="col-12 px-0 fw-bold fs-5 mb-3">
              مدت زمان آماده سازی
            </div>
            <div
              className="col-12 px-0 py-3"
              onClick={() => this.setState({ time: "1" })}
            >
              <input
                checked={this.state.time}
                class="form-check-input"
                type="radio"
                name="timeRadio"
              />
              <span className="me-3 fw-bold small align-middle">
                محصول دارای زمان آماده سازی می باشد
              </span>
            </div>
            {this.state.time && this.state.time !== 0 ? (
              <div className="row mx-0 px-0 py-2 mb-3 justify-content-center">
                <div className="col-2 px-2 align-self-center text-center">
                  <p className="fw-bold">دقیقه</p>
                  <Dropdown
                    className="d-inline-block"
                    isOpen={this.state.minute}
                    toggle={() => this.setState({ minute: !this.state.minute })}
                  >
                    <DropdownToggle className="border color-main bg-light-gray">
                      {this.state.selected_minute}
                    </DropdownToggle>
                    <DropdownMenu
                      className="max-h-50 rounded-3"
                      style={{ minWidth: "80px" }}
                    >
                      {this.state.minutes.map(
                        (time, t) =>
                          this.state.minutes.length - 1 !== t && (
                            <DropdownItem
                              className="text-center"
                              onClick={() =>
                                this.setState({ selected_minute: time })
                              }
                            >
                              {time}
                            </DropdownItem>
                          )
                      )}
                    </DropdownMenu>
                  </Dropdown>
                </div>
                <div className="col-2 px-2 align-self-center text-center">
                  <p className="fw-bold">ساعت</p>
                  <Dropdown
                    className="d-inline-block"
                    isOpen={this.state.hour}
                    toggle={() => this.setState({ hour: !this.state.hour })}
                  >
                    <DropdownToggle className="border color-main bg-light-gray">
                      {this.state.selected_hour}
                    </DropdownToggle>
                    <DropdownMenu
                      className="max-h-50 rounded-3"
                      style={{ minWidth: "80px" }}
                    >
                      {this.state.hours.map(
                        (time, t) =>
                          this.state.hours.length - 1 !== t && (
                            <DropdownItem
                              className="text-center"
                              onClick={() =>
                                this.setState({ selected_hour: time })
                              }
                            >
                              {time}
                            </DropdownItem>
                          )
                      )}
                    </DropdownMenu>
                  </Dropdown>
                </div>
                <div className="col-2 px-2 align-self-center text-center">
                  <p className="fw-bold">روز</p>
                  <Dropdown
                    className="d-inline-block"
                    isOpen={this.state.day}
                    toggle={() => this.setState({ day: !this.state.day })}
                  >
                    <DropdownToggle className="border color-main bg-light-gray">
                      {this.state.selected_day}
                    </DropdownToggle>
                    <DropdownMenu
                      className="max-h-50 rounded-3"
                      style={{ minWidth: "80px" }}
                    >
                      {this.state.days.map(
                        (time, t) =>
                          this.state.days.length - 1 !== t && (
                            <DropdownItem
                              className="text-center"
                              onClick={() =>
                                this.setState({ selected_day: time })
                              }
                            >
                              {time}
                            </DropdownItem>
                          )
                      )}
                    </DropdownMenu>
                  </Dropdown>
                </div>
              </div>
            ) : (
              ""
            )}
            <div
              className="col-12 px-0 py-3"
              onClick={() => this.setState({ time: 0 })}
            >
              <input
                checked={this.state.time === 0}
                class="form-check-input"
                type="radio"
                name="timeRadio"
              />
              <span className="me-3 fw-bold small align-middle">
                محصول آماده است
              </span>
            </div>
            <div
              className="col-12 px-0 py-3"
              onClick={() => this.setState({ time: null })}
            >
              <input
                class="form-check-input"
                checked={this.state.time === null}
                type="radio"
                name="timeRadio"
              />
              <span className="me-3 fw-bold small align-middle">
                محصول نیاز به زمان آماده سازی ندارد
              </span>
            </div>
            <div className="col-12 px-0 py-2 mt-3 align-self-center">
              <button
                onClick={() => {
                  this.state.time === null
                    ? this.props.timeChange(null)
                    : this.state.time === 0
                    ? this.props.timeChange(0)
                    : this.props.timeChange(
                        this.state.selected_day * 24 * 60 +
                          this.state.selected_hour * 60 +
                          this.state.selected_minute
                      );
                  this.props.changeModal(false);
                }}
                className="btn w-100 rounded28 bg-color-main py-2 text-white fw-bold"
              >
                ذخیره
              </button>
            </div>
          </ModalBody>
        </Modal>
      </div>
    );
  }
}

export default PreparationTime;
